module.exports = __webpack_public_path__ + "img/sign-up-receive.f02fcc6.png";